import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { CustomIntervalDialogModule } from '../custom-interval-dialog/custom-interval-dialog.module';

import { CustomDateSelectWrapperComponent } from './custom-date-select-wrapper.component';

@NgModule({
  declarations: [
    CustomDateSelectWrapperComponent
  ],
  imports: [
    CommonModule,

    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatDialogModule,
    CustomIntervalDialogModule,
  ],
  exports: [CustomDateSelectWrapperComponent]
})
export class CustomDateSelectWrapperModule { }
